import store from "@/store";
import { Action, config, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import { Viewpoint } from "@/api/model/Viewpoint";
import UserAuth from "@/store/auth/UserAuth";
import DecisionModule from "@/store/decision/Decision";
import { Choice } from "@/api/model/Choice";
import _ from "lodash";
import Vue from "vue";
import { ChoiceScore } from "@/api/model/ViewpointChoiceScore";
import ViewpointsModule from "@/store/viewpoint/viewpoint";

config.rawError = true

const name = 'favourites';
if (module.hot) {
    if (store.hasModule(name)) {
        store.unregisterModule(name);
    }
}

@Module({dynamic: true, store, name: name, namespaced: true})
export default class FavouritesModule extends VuexModule {

    favouriteIds: string[] = [];

    favourites: { [id: string]: Choice } = {};
    favouritesScores: { [id: string]: ChoiceScore } = {};

    @Mutation
    setFavouriteIds(ids: string[]) {
        this.favouriteIds = ids;
    }

    @Mutation
    setFavourites(favourites: Choice[]) {
        this.favourites = _.keyBy(favourites, 'id');
    }

    @Mutation
    addFavouriteChoice(choice: Choice) {
        if (choice.id) {
            Vue.set(this.favourites, choice.id, choice);
        }
    }

    @Mutation
    setFavouritesScores(scores: { [id: string]: ChoiceScore }) {
        this.favouritesScores = scores;
    }


    @Action
    async getFavourites() {
        let decision = getModule(DecisionModule).decision;
        let userId = getModule(UserAuth).userId
        if (decision) {
            let favouriteIds = await VIEWPOINT_API.getFavouriteList(decision.decisionId, userId);
            if (favouriteIds.length) {
                let favourites = await VIEWPOINT_API.getChoices(decision.choicesSourceId, favouriteIds);
                this.setFavourites(favourites)
                let scores = await VIEWPOINT_API.getViewpointScore(decision.decisionId, 'published', getModule(ViewpointsModule).selectedViewpointId, favouriteIds)
                this.setFavouritesScores(scores.choiceScores)

            }
            this.setFavouriteIds(favouriteIds)

        }
    }

    @Action
    async addFavourite(choiceId: string) {
        let decision = getModule(DecisionModule).decision;
        let userId = getModule(UserAuth).userId;
        if (!decision || !userId) return;

        let ids = _.cloneDeep(this.favouriteIds);
        ids.splice(ids.length, 0, choiceId);


        let choiceFuture = VIEWPOINT_API.getChoices(decision.choicesSourceId, [choiceId])
        let updatedIds = await VIEWPOINT_API.updateFavouriteList(decision.decisionId, userId, ids);
        let scores = await VIEWPOINT_API.getViewpointScore(decision.decisionId, 'published', getModule(ViewpointsModule).selectedViewpointId, updatedIds)

        this.setFavouritesScores(scores.choiceScores)
        this.addFavouriteChoice((await choiceFuture)[0]);
        this.setFavouriteIds(updatedIds)

        return updatedIds;
    }

    @Action
    async removeFavourite(choiceId: string) {
        let decision = getModule(DecisionModule).decision;
        let userId = getModule(UserAuth).userId;
        if (!decision || !userId) return;

        let ids = _.cloneDeep(this.favouriteIds);
        ids.splice(ids.indexOf(choiceId), 1);

        let updatedIds = await VIEWPOINT_API.updateFavouriteList(decision.decisionId, userId, ids);
        this.setFavouriteIds(updatedIds)

        return updatedIds;
    }

    @Action
    async updateFavouriteOrder(choiceIds: string[]) {
        this.setFavouriteIds(choiceIds)
        let decision = getModule(DecisionModule).decision;
        let userId = getModule(UserAuth).userId;
        if (!decision || !userId) return;

        let updatedIds = await VIEWPOINT_API.updateFavouriteList(decision.decisionId, userId, choiceIds);
        this.setFavouriteIds(updatedIds)
        return updatedIds;
    }

    @Action
    async updateScores() {
        let decision = getModule(DecisionModule).decision;
        if (decision && this.favouriteIds.length) {
            let scores = await VIEWPOINT_API.getViewpointScore(decision.decisionId, 'published', getModule(ViewpointsModule).selectedViewpointId, this.favouriteIds)
            this.setFavouritesScores(scores.choiceScores)
        }
    }

    @Action
    async clear() {
        this.setFavouriteIds([])
        this.setFavouritesScores({})
        this.setFavourites([])
    }

}